export enum BcmVersions {
    Freemium = 'Freemium', // outdated
    Excellent = 'Excellent',
    Prestige = 'Prestige',
    Premium = 'Premium',
}
